import type { THRType } from "api/companyExternalIntegrations";
import type { TTicketingIntegrationType } from "models/TicketingIntegrationTicketModel";
import type { TTicketDuration } from "utils/durationsOptions";

import { List, Record } from "immutable";

import type { TOnCallType } from "./OnCallIntegrationScheduleModel";

export type TDayOfTheWeek = 0 | 1 | 2 | 3 | 4 | 5 | 6;
export type TRoutineReminderSchedule = { daysOfTheWeek: TDayOfTheWeek[]; hour: number; minute: number };

type TCompanyServerData = Omit<
  typeof defaults,
  "allowedDurations" | "integratedToHRs" | "integratedToTicketingIntegrations"
> & {
  allowedDurations: TTicketDuration[];
  integratedToHRs: THRType[];
  integratedToTicketingIntegrations: TTicketingIntegrationType[];
};

type TTicketingIntegration = "jira";

const defaults = {
  allowedDurations: List<TTicketDuration>(),
  createdAt: new Date(0),
  enableAccessReviews: false,
  enableExternalAuditLogs: false,
  enableUserAttributes: false,
  forceAccessReviewsImmediateRevoke: false,
  id: "",
  integratedToHRs: List<THRType>(),
  integratedToInsights: false,
  integratedToOnCalls: List<TOnCallType>(),
  integratedToSlack: false,
  integratedToTeams: false,
  integratedToTicketingIntegrations: List<TTicketingIntegrationType>(),
  name: "",
  pendingAccessReportsReminderSchedule: null as null | TRoutineReminderSchedule,
  pendingRequestsReminderSchedule: null as null | TRoutineReminderSchedule,
  siteName: null as null | string,
  syncLimitInMinutes: 0,
  ticketingIntegration: null as null | TTicketingIntegration,
  timeZone: null as null | string,
};

export class CompanyModel extends Record<typeof defaults>(defaults) {
  static fromServerData(data: TCompanyServerData) {
    return new CompanyModel({
      ...data,
      allowedDurations: List(data.allowedDurations),
      createdAt: new Date(data.createdAt),
      integratedToHRs: List(data.integratedToHRs),
      integratedToOnCalls: List(data.integratedToOnCalls),
      integratedToTicketingIntegrations: List(data.integratedToTicketingIntegrations),
    });
  }
}
